export default __webpack_public_path__ + "static/media/heimdall.5e33d451.svg";